
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrent() {



  const cardData =
  {
    keyword: 'Kia Carens on Rent in Pune',
    heading: 'AB Ghule Cabs: Kia Carens on Rent in Pune',
    headingDescription: 'AB Ghule Cabs offers reliable, comfortable, and affordable Kia Carens rental services in Pune. Whether you are planning a family road trip, corporate travel, or a sightseeing tour, our well-maintained Kia Carens vehicles are perfect for all your travel needs. With spacious interiors, modern amenities, and experienced drivers, we ensure a comfortable and stress-free journey for you and your group.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Kia Carens Rental in Pune',
    "topPlaces": [
  {
    title: "Spacious and Comfortable",
    description: "Our Kia Carens vehicles offer plenty of space, comfortable seating, and air-conditioning, making it an ideal choice for long-distance journeys or family trips."
  },
  {
    title: "Experienced Drivers",
    description: "Our professional drivers are well-trained to ensure a smooth and safe journey. They are familiar with the best routes and tourist spots, offering a relaxed and enjoyable ride."
  },
  {
    title: "Perfect for Families and Groups",
    description: "The Kia Carens comfortably accommodates up to 7 passengers, making it ideal for family trips or small group travel. It offers generous legroom and storage space for your luggage."
  },
  {
    title: "24/7 Availability",
    description: "We offer round-the-clock Kia Carens rental services. Whether you need an early morning pick-up or a late-night return, AB Ghule Cabs is always ready to serve you."
  },
  {
    title: "Customizable Packages",
    description: "Choose from a variety of customizable packages for family vacations, corporate events, airport transfers, or sightseeing tours. Tailor the itinerary to your needs and enjoy a seamless travel experience."
  },
  {
    title: "Well-Maintained Vehicles",
    description: "Our Kia Carens vehicles are regularly serviced and maintained to ensure a trouble-free ride. We prioritize cleanliness and hygiene, ensuring that all vehicles are sanitized before every trip."
  },
  {
    title: "Tourist Sightseeing in Pune and Nearby Areas",
    description: "Our Kia Carens is perfect for sightseeing within Pune and surrounding destinations such as Lonavala, Mahabaleshwar, and Sinhagad Fort. Explore the beauty of these locations in comfort."
  },
  {
    title: "Easy Booking Process",
    description: "Booking your Kia Carens rental is simple and hassle-free. You can book online or by phone, and our customer support team will assist you in customizing your trip to fit your needs."
  },
  {
    title: "No Hidden Charges",
    description: "We believe in transparency. The price you see at the time of booking is the price you pay, with no hidden or additional charges. Enjoy a straightforward and affordable rental experience with AB Ghule Cabs."
  },
  {
    title: "Affordable Pricing",
    description: "We offer competitive rates for both short-term and long-term rentals. Whether it's a one-day trip or an extended travel schedule, we provide transparent and affordable pricing."
  }
],


services: [
    {
      "name": "Kia Carens on Rent in Pune",
      description: "Looking for a Kia Carens on rent in Pune? AB Ghule Cabs offers well-maintained Kia Carens for various travel needs. Whether it's a family trip, corporate event, or a long-distance journey, our Kia Carens provide comfort, style, and ample space."
    },
    {
      "name": "Kia Carens for Rent in Pune",
      description: "Rent a Kia Carens in Pune with AB Ghule Cabs. Our fleet includes the latest Kia Carens, ideal for both local and outstation trips. Book today for a comfortable, reliable, and stylish ride for any occasion."
    },
    {
      "name": "Pune to Shirdi Kia Carens on Rent",
      description: "Heading to Shirdi from Pune? Rent a Kia Carens for a comfortable, spacious, and safe journey. AB Ghule Cabs offers Kia Carens on rent for trips from Pune to Shirdi, with flexible rental packages designed to suit your needs."
    },
    {
      "name": "Kia Carens for Rent for Corporate",
      description: "Looking for a corporate car rental in Pune? AB Ghule Cabs provides Kia Carens for corporate hire. Whether it’s for executive travel, meetings, or business tours, our Kia Carens ensure your corporate travel is comfortable and professional."
    },
    {
      "name": "Kia Carens Hire for Outstation",
      description: "Rent a Kia Carens for your outstation trips with AB Ghule Cabs. Our Kia Carens are perfect for long-distance travel, offering spacious seating and modern amenities for a comfortable journey to various destinations across Maharashtra and beyond."
    },
    {
      "name": "Pune to Nashik Kia Carens on Rent",
      description: "Going from Pune to Nashik? Rent a Kia Carens for a comfortable and smooth journey. Our Kia Carens come with ample legroom, air conditioning, and modern features to make your travel from Pune to Nashik enjoyable."
    },
    {
      "name": "Pune to Goa Kia Carens on Rent",
      description: "Book a Kia Carens for your trip from Pune to Goa. AB Ghule Cabs offers Kia Carens on rent for long-distance journeys like Pune to Goa. With a spacious interior and luxury features, enjoy a relaxed ride to one of India's most popular destinations."
    },
    {
      "name": "Pune to Mumbai Kia Carens on Rent",
      description: "Traveling from Pune to Mumbai? Rent a Kia Carens for a smooth and hassle-free ride. AB Ghule Cabs provides reliable Kia Carens for Mumbai trips, ensuring comfort and convenience throughout your journey."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Kia Carens on Rent",
      description: "Going for an Ashtavinayak Darshan trip from Pune? Rent a Kia Carens for a comfortable and spacious journey to all the temples. AB Ghule Cabs offers customizable packages for your Ashtavinayak Darshan trip, making your journey peaceful and convenient."
    },
    {
      "name": "Pune to Jyotirlinga Darshan Kia Carens on Rent",
      description: "Book a Kia Carens for your Jyotirlinga Darshan from Pune. AB Ghule Cabs offers comfortable, well-maintained Kia Carens for religious tours like the Jyotirlinga pilgrimage. Enjoy a smooth and spiritual journey with our well-equipped cars."
    },
    {
      "name": "Kia Carens Cabs on Rent in Pune",
      description: "Looking for a luxury cab in Pune? AB Ghule Cabs offers Kia Carens cabs for rent. Whether for personal use, family trips, or business purposes, our Kia Carens ensure a comfortable and stylish ride across Pune and nearby cities."
    },
    {
      "name": "Luxury Cars Kia Carens Rental Services",
      description: "AB Ghule Cabs provides luxury car rental services with Kia Carens in Pune. Our fleet includes well-maintained Kia Carens, ideal for those seeking a blend of luxury and comfort for both local and outstation trips."
    },
    {
      "name": "Luxury Car Monthly Rental",
      description: "If you're looking for a luxury car rental in Pune, AB Ghule Cabs offers monthly rental options for the Kia Carens. Whether it's for business, leisure, or regular travel, our monthly rental plans are designed to offer convenience and affordability."
    },
    {
      "name": "Kia Carens on Rent for Outstation",
      description: "Rent a Kia Carens for your outstation trips with AB Ghule Cabs. Our Kia Carens are spacious and perfect for long drives to destinations like Shirdi, Mahabaleshwar, Goa, and more. Book your outstation trip today for a comfortable ride."
    },
    {
      "name": "7-Seater Kia Carens on Rent in Pune",
      description: "Rent a 7-seater Kia Carens in Pune with AB Ghule Cabs. Whether you're traveling with family or a group, our 7-seater Kia Carens offer plenty of space and comfort for everyone. Book now for your next trip."
    },
    {
      "name": "7-Seater Kia Carens on Rent in Pimpri Chinchwad",
      description: "Looking for a 7-seater Kia Carens in Pimpri Chinchwad? AB Ghule Cabs offers Kia Carens on rent for all your travel needs. Whether it's for a local trip, corporate event, or outstation journey, our Kia Carens are available in Pimpri Chinchwad at competitive rates."
    },
    {
      "name": "Kia Carens On Rent in Pune Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Kia Carens On Rent in Pune. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Kia Carens on Rent in Pune Near Me", "- Kia Carens on Rent in Pune Near Me Contact Number"],
    ["Kia Carens for Rent in Pune", "- Pune to Shirdi Kia Carens on Rent"],
    ["Kia Carens for Rent for Corporate", "- Kia Carens Hire for Outstation"],
    ["Pune to Nashik Kia Carens on Rent", "- Pune to Goa Kia Carens on Rent"],
    ["Pune to Mumbai Kia Carens on Rent", "- Pune to Ashtavinayak Darshan Kia Carens on Rent"],
    ["Pune to Jyotirlinga Darshan Kia Carens on Rent", "- Kia Carens Cabs On Rent in Pune"],
    ["Luxury Cars Kia Carens Rental Services", "- Luxury Car Monthly Rental"],
    ["Kia Carens on Rent in Pune", "- Kia Carens on Rent for Outstation"],
    ["7 Seater Car on Rent in Pune", "- 7 Seater Kia Carens on Rent in Pimpri Chinchwad"],
    ["Kia Carens on Rent in Pimpri Chinchwad", ""]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Modern and Stylish Ride",
      WhyChoosedescription: "The Kia Carens offers a sleek, modern design that ensures a premium travel experience. With its spacious interiors, advanced features, and stylish exterior, it is a perfect vehicle for both business and leisure trips in Pune."
    },
    {
      WhyChooseheading: "Comfortable and Spacious Interior",
      WhyChoosedescription: "The Kia Carens can comfortably accommodate up to 7 passengers with ample legroom and luggage space. Its premium seating and cabin design ensure that your journey is always comfortable, whether it's a short city ride or a long-distance trip."
    },
    {
      WhyChooseheading: "Well-Maintained and Clean Vehicles",
      WhyChoosedescription: "At AB Ghule Cabs, we ensure that all our Kia Carens are regularly serviced, cleaned, and inspected to provide you with a smooth and enjoyable ride. We prioritize hygiene and cleanliness to give you the best travel experience."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive rental rates for the Kia Carens without any hidden charges. Our pricing is simple and transparent, ensuring you get value for money. Whether you need the vehicle for a few hours or several days, we offer cost-effective rental solutions."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our drivers are highly trained, experienced, and committed to providing you with a safe, comfortable, and pleasant journey. They are well-versed in local routes and can also assist you with any special requirements during your ride."
    },
    {
      WhyChooseheading: "Flexible Rental Packages",
      WhyChoosedescription: "Whether you need the Kia Carens for a family outing, business trip, or special event, we offer flexible rental packages to suit your needs. You can rent the car for a few hours, a full day, or longer, depending on your requirements."
    },
    {
      WhyChooseheading: "Convenient Booking Process",
      WhyChoosedescription: "Booking the Kia Carens with AB Ghule Cabs is quick and easy. You can book through our website, mobile app, or call our customer service to make arrangements. We ensure a hassle-free booking process that fits into your schedule."
    },
    {
      WhyChooseheading: "Customer Satisfaction Guaranteed",
      WhyChoosedescription: "We value our customers and aim to provide an exceptional experience. Our commitment to quality service and customer satisfaction ensures that every journey with AB Ghule Cabs is memorable and stress-free."
    }
  ]
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book the Kia Carens on rent?',
      answer: 'You can book the Kia Carens via our website, mobile app, or by calling our customer service team. Our booking process is quick and hassle-free.',
    },
    {
      id: 'FAQ2',
      question: 'How many passengers can the Kia Carens accommodate?',
      answer: 'The Kia Carens can accommodate up to 7 passengers, making it an ideal choice for group travel, family trips, or business outings.',
    },
    {
      id: 'FAQ3',
      question: 'Is the Kia Carens available for both local and outstation trips?',
      answer: 'Yes, the Kia Carens is available for local trips within Pune as well as outstation travel. Whether you’re planning a city tour or a long-distance journey, the Carens is a great option.',
    },
    {
      id: 'FAQ4',
      question: 'Are the vehicles air-conditioned?',
      answer: 'Yes, all our Kia Carens vehicles are fully air-conditioned to ensure a comfortable and pleasant journey, no matter the weather.',
    },
    {
      id: 'FAQ5',
      question: 'What is the rental cost for the Kia Carens?',
      answer: 'The rental cost depends on factors like the rental duration and the distance to be covered. We offer competitive pricing and will provide you with a detailed quote upon booking.',
    },
    {
      id: 'FAQ6',
      question: 'Can I rent the Kia Carens for a few hours?',
      answer: 'Yes, we offer flexible rental packages, including hourly rentals for short trips or events. You can rent the Kia Carens for as long as you need, from a few hours to multiple days.',
    },
    {
      id: 'FAQ7',
      question: 'Are the drivers experienced and reliable?',
      answer: 'Yes, all our drivers are professionally trained, experienced, and familiar with local and outstation routes. They ensure a safe and comfortable ride at all times.',
    },
    {
      id: 'FAQ8',
      question: 'How do I make payment for the rental?',
      answer: 'Payments for the Kia Carens rental can be made via cash, credit/debit cards, or through online payment on our mobile app, offering you flexibility and convenience.',
    },
    {
      id: 'FAQ9',
      question: 'Can I make changes to my booking after confirming it?',
      answer: 'Yes, modifications to your booking can be made, subject to availability. Please contact our customer service team for assistance with changes to your reservation.',
    },
    {
      id: 'FAQ10',
      question: 'Do you provide rental services for corporate purposes?',
      answer: 'Yes, we offer rental services for corporate travel, including business meetings, corporate events, and team outings. Custom packages can be arranged for your company.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Akash Singh',
      feedback: 'I rented the Kia Carens for a family vacation, and it was a fantastic experience. The car was spacious, clean, and comfortable, perfect for our long road trip. The driver was courteous and professional. I highly recommend AB Ghule Cabs for anyone looking to rent a vehicle in Pune.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Nisha Deshmukh',
      feedback: 'We rented the Kia Carens for a corporate outing, and it was an ideal choice. The vehicle was well-maintained and equipped with all the necessary amenities for a comfortable ride. The service was excellent, and the driver was punctual and professional. Definitely my go-to service for future rentals.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Kia Carens on Rent in Pune | Affordable Kia Carens Car Hire & Rentals</title>
  <meta name="description" content="Kia Carens rental services in Pune. Offering spacious and comfortable 7-seater Kia Carens for local and outstation trips including Shirdi, Nashik, Goa, Mumbai, Ashtavinayak, and more. Book online or call +91 8624029699 for bookings." />
  <meta name="keywords" content="Kia Carens on Rent in Pune, Kia carens on rent in pune near me, Kia Carens for rent in pune, Pune to Shirdi Kia Carens on Rent, Kia Carens for rent for corporate, Kia Carens hire for outstation, Pune to Nashik Kia Carens on Rent, Pune to Goa Kia Carens on rent, Pune to Mumbai Kia Carens on rent, Pune to Ashtavinayak darshan Kia Carens on rent, Pune to Jyotirlinga darshan Kia Carens on Rent, Kia Carens Cabs On Rent In Pune, Luxury Cars Kia Carens Rental Services, luxury car monthly rental, Kia Carens on rent in Pune, Kia Carens on rent for outstation, 7 seater car on rent in Pune, 7 seater Kia Carens on rent in Pimpri Chinchwad, Kia Carens on rent in Pimpri Chinchwad" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Kia Carens on Rent in Pune | Affordable Kia Carens Car Hire & Rentals" />
  <meta property="og:description" content="Kia Carens rental services in Pune. Offering spacious and comfortable 7-seater Kia Carens for local and outstation trips including Shirdi, Nashik, Goa, Mumbai, Ashtavinayak, and more. Book online or call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/kia-carens-rent.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/kia-carens-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Kia Carens on Rent in Pune",
        description: "Kia Carens rental services in Pune. Offering spacious and comfortable 7-seater Kia Carens for local and outstation trips including Shirdi, Nashik, Goa, Mumbai, Ashtavinayak, and more. Book online or call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/kia-carens-on-rent-in-pune",
        "logo": "https://abghulecabs.com/images/kia-carens-rent.jpg",
        "image": "https://abghulecabs.com/images/kia-carens-rent.jpg",
        "priceRange": "₹2500 - ₹6000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/kia-carens-on-rent-in-pune",
          "priceCurrency": "INR",
          "price": "2500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.6",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sujay P"
            },
            "datePublished": "2024-10-25",
            "reviewBody": "Had a fantastic experience with the Kia Carens! The car was spacious and comfortable for our trip to Nashik. Highly recommend AB Ghule Cabs for any outstation travel!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anjali M"
            },
            "datePublished": "2024-09-15",
            "reviewBody": "The Kia Carens was perfect for our family trip to Goa. It was a smooth ride, and the driver was friendly. Would definitely book again!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune Kia Carens Rentals",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/kia-carens-on-rent-in-pune"
        },
        "keywords": "Kia Carens on Rent in Pune, Kia carens on rent in pune near me, Kia Carens for rent in pune, Pune to Shirdi Kia Carens on Rent, Kia Carens for rent for corporate, Kia Carens hire for outstation, Pune to Nashik Kia Carens on Rent, Pune to Goa Kia Carens on rent, Pune to Mumbai Kia Carens on rent, Pune to Ashtavinayak darshan Kia Carens on rent, Pune to Jyotirlinga darshan Kia Carens on Rent, Kia Carens Cabs On Rent In Pune, Luxury Cars Kia Carens Rental Services, luxury car monthly rental, Kia Carens on rent in Pune, Kia Carens on rent for outstation, 7 seater car on rent in Pune, 7 seater Kia Carens on rent in Pimpri Chinchwad, Kia Carens on rent in Pimpri Chinchwad"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/48.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Kiacarenceonrent;